import React, { FC, SVGProps } from "react";

export const IconLogout: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 16,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M13.8213 0.0136719C14.3981 0.0761924 14.9267 0.352848 15.3184 0.779297C15.7632 1.26379 16 1.90415 16 2.55566V13.4443C16 14.0959 15.7632 14.7362 15.3184 15.2207C14.8708 15.7081 14.2442 16 13.5713 16H10C9.44771 16 9 15.5523 9 15C9 14.4477 9.44772 14 10 14H13.5713C13.6561 14 13.7565 13.9641 13.8447 13.8682C13.9356 13.7692 14 13.6179 14 13.4443V2.55566C14 2.38214 13.9356 2.23077 13.8447 2.13184C13.7786 2.05997 13.7058 2.02144 13.6377 2.00684L13.5713 2H10C9.44771 2 9 1.55228 9 1C9 0.447715 9.44771 0 10 0L13.5713 0L13.8213 0.0136719ZM5.02051 3.31641C5.39819 2.91355 6.03067 2.89294 6.43359 3.27051C6.83632 3.6482 6.85702 4.28072 6.47949 4.68359L4.30762 7H11L11.1025 7.00488C11.6067 7.05623 12 7.48233 12 8C11.9999 8.51756 11.6066 8.94379 11.1025 8.99512L11 9H4.30762L6.47949 11.3164L6.5459 11.3945C6.85302 11.7974 6.81117 12.3755 6.43359 12.7295C6.0558 13.0834 5.47589 13.0878 5.09375 12.7549L5.02051 12.6836L0.628906 8L5.02051 3.31641Z"
        fill="currentColor"
      />
    </svg>
  );
};
